import App from 'containers/App';
import { UIProvider } from 'mymoria-ui';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { ScrollToTop } from 'components';
// this import is required in order to augment emotion builtin Theme interface
import 'mymoria-ui/styles/theme';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <Router>
    <UIProvider>
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </UIProvider>
  </Router>,
  document.getElementById('root'),
);

serviceWorker.unregister();
